function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint no-param-reassign:"off", no-prototype-builtins:"off" */

// Represents a fixed list of string values that can be accessed and deserialized to numbers.
// This should be used instead of Enum when a service you are talking to returns numeric values, but
// you want to represent them as the String equivalents in Dashboard code.
//
// Construct a new enum by invoking the constructor with an array of strings:
//
//   Colors = NumericEnum.create(['RED', 'GREEN', 'BLUE'])
//
// In browsers that support Object.freeze(), the values of the resulting enum
// cannot be modified and changes will be silently ignored:
//
//   Colors.GREEN = 'YELLOW'
//   Colors.GREEN // 'GREEN'
//

export default class NumericEnum {
  constructor(...values) {
    _defineProperty(this, "values", void 0);
    let realValues;
    if (values.length === 1 && Array.isArray(values[0])) {
      realValues = values[0];
    } else {
      // TypeScript can't figure out that we ruled out [readonly T[]]
      realValues = values;
    }
    const newValues = [];
    for (const [i, value] of realValues.entries()) {
      newValues[i] = value;
      this[value] = value;
    }
    this.values = newValues;
    if (Object.freeze) {
      Object.freeze(this.values);
      Object.freeze(this);
    }
  }

  // Prefer using this over new for anything using TypeScript, since it
  // otherwise it won't know about the dynamic fields
  // If you're dealing with something new, it's probably better to use native enums instead.
  static create(values) {
    return new NumericEnum(values);
  }
  static createFromObject(valuesObject) {
    const array = [];
    for (const key in valuesObject) {
      if (!valuesObject.hasOwnProperty(key)) {
        // we don't want to process properties inherited from the object's prototype chain
        // this is useful when creating NumericEnum from a typescript Enum
        continue;
      }
      const value = valuesObject[key];
      if (typeof value !== 'number') {
        throw new TypeError(`${value} isn't a number. Values in the object should correspond to index in the array and should be a number`);
      }
      array[value] = key;
    }
    return NumericEnum.create(array);
  }
  hasValue(value) {
    return this.hasOwnProperty(value);
  }

  // Provides support for Ember.attr() serialization with Ember Model.
  // get String, return Number
  serialize(value) {
    if (value === null || typeof value === 'undefined') {
      return value;
    } else if (this.hasValue(value)) {
      return this.values.indexOf(value);
    } else {
      throw new Error(`${value} isn't a member of this enum`);
    }
  }

  // Provides support for Ember.attr() deserialization with Ember Model.
  deserialize(value) {
    if (value === null || typeof value === 'undefined') {
      return value;
      // eslint-disable-next-line unicorn/prefer-number-properties -- TODO: try switching to Number.isNan
    } else if (isNaN(value) && typeof value === 'string') {
      if (this.hasValue(value)) {
        return value;
      } else {
        throw new Error(`${value} is not a numeric; Use Enum for String only Enums`);
      }
    } else {
      if (this.values.length - 1 >= value) {
        return this.values[value];
      } else {
        throw new Error(`Index ${value} out of bounds. Enum only has ${this.values.length} values. `);
      }
    }
  }
}